module.exports = __webpack_public_path__ + "static/ocean-robbins-veggies-square.67741d59.jpg";